<!--
 * @Description: 
 * @Author: dezhi
 * @Date: 2020-11-03 16:51:40
 * @LastEditTime: 2021-04-21 11:51:14
 * @LastEditors: zhaoshuai
-->
<template>
  <div class="flex sharing-v">
    <Header />
    <div class="wrapper">
      <div class="info-area" style="background: #044989">
        <h3 class="text-center" style="color:#fff;">
          准考证打印
        </h3>
      </div>
      <div class="box-shadow">
        <a-row type="flex" justify="center" align="middle">
          <a-col :xs="24" :lg="8" :xl="8">
            <div class="fixed-box" v-if="isAct" @click.self="isAct = false">
              <Online
                class="admission"
                id="canvas"
                :isAc="isAct"
                v-if="isOnline"
                :examInfo="examInfo"
              />
              <Offline
                class="admission"
                id="canvas"
                :isAc="isAct"
                :examInfo="examInfo"
                v-else
              />
              <div
                class="download-mask"
                :class="{ active: isHover, online: isOnline }"
                @mouseenter="isHover = true"
                @mouseleave="isHover = false"
              >
                <a-button
                  class="download"
                  type="danger"
                  v-if="isHover"
                  @click="canvas"
                >
                  下载准考证
                </a-button>
              </div>
            </div>
            <img src="" id="avatar" alt="" />
            <div class="box">
              <div class="admission-info">
                <p v-if="examInfo.examStartdate">
                  考试时间：{{ examInfo.examStartdate }}
                </p>
                <p v-if="examInfo.admissionNo">
                  准考证号：{{ examInfo.admissionNo }}
                </p>
                <p v-if="studentInfo.data.examEnrollInfoDto.areaName">
                  考点： {{ studentInfo.data.examEnrollInfoDto.areaName }}
                </p>
                <p v-if="examInfo.examVenue">
                  考场名称：{{ examInfo.examVenue }}
                </p>
                <p v-if="examInfo.examLocation">
                  具体地址：{{ examInfo.examLocation }}
                </p>
              </div>
              <div style="text-align: center; margin: 20px">
                <a-button
                  type="primary"
                  @click="downloadCertifi"
                  class="my-button"
                >
                  <i class="icon-xiazai1"></i>
                  下载准考证
                </a-button>
              </div>
              <a-alert
                class="warning-alert"
                description="下载后请打印准考证，线下考试时需凭打印的准考证和身份证件进入考场"
                type="warning"
                show-icon
              />
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "../components/Header";
import Online from "@/components/admission/online.vue";
import Offline from "@/components/admission/offline.vue";
import { createNamespacedHelpers } from "vuex";
import html2canvas from "html2canvas";
const { mapActions } = createNamespacedHelpers("apply");
export default {
  name: "Login",
  components: {
    Header,
    Online,
    Offline,
  },
  data() {
    return {
      needUpdate: false,
      userInfo: {},
      stepTwoColor: "#ccc",
      src: "",
      isAct: false,
      isHover: false,
      isOnline: true,
      examInfo: {},
      studentInfo: {},
    };
  },
  mounted() {
    this.userInfo = localStorage.getItem("apply_userInfo")
      ? JSON.parse(localStorage.getItem("apply_userInfo"))
      : "";
    this.getExamInfoEvt(this.userInfo);
  },
  created() {
    this.studentInfo = localStorage.getItem("apply_studentInfo")
      ? JSON.parse(localStorage.getItem("apply_studentInfo"))
      : "";
  },
  methods: {
    ...mapActions([
      "getStudentInfo",
      "getExamInfo",
      "getDownloadTime",
      "downloadBookAct",
    ]),
    canvas() {
      this.isAct = true;
      let htmlDom = document.querySelector("#canvas");
      let $this = this;
      html2canvas(htmlDom, {
        logging: false, //日志开关，便于查看html2canvas的内部执行流程
        // x: 0,
        // y: window.pageYOffset,
        scale: 2,
        dpi: 200,
        useCORS: true, // 【重要】开启跨域配置
        allowTaint: true,
        taintTest: false, //是否在渲染前测试图片
        backgroundColor: "white",
        width: htmlDom.offsetWidth,
        height: htmlDom.offsetHeight,
        scrollY: 0,
        scrollX: 0,
        // width: window.screen.availWidth, //dom 原始宽度
        // height: window.screen.availHeight,
        // windowWidth: document.body.scrollWidth,
        // windowHeight: document.body.scrollHeight,
      }).then((canvas) => {
        $this.getDownloadTime($this.$route.query.id);
        let oImg = new Image();
        oImg.src = canvas.toDataURL("image/png"); // 导出图片
        // document.body.appendChild(oImg); // 将生成的图片添加到body
        // $this.src = canvas.toDataURL("image/png"); // 导出图片
        const alink = document.createElement("a");
        alink.href = canvas.toDataURL("image/png");
        alink.download = `${$this.userInfo.realName}.png`;
        alink.click();
        $this.isAct = false;
      });
    },
    preview(b) {
      if (
        navigator.userAgent.match(
          /(iPhone|iPod|Android|ios|iOS|iPad|Backerry|WebOS|Symbian|Windows Phone|Phone)/i
        )
      ) {
        //显示移动端的代码
        this.$warning({
          title: "请注意",
          content: "请在pc端打开下载",
          okText: "知道了",
          okType: "primary",
          maskClosable: true,
        });
      } else {
        //显示非移动端的代码
        this.isAct = true;
        this.isOnline = b;
      }
    },
    downloadCertifi() {
      const _userInfo = localStorage.getItem("apply_userInfo");
      const userInfo = JSON.parse(_userInfo);
      const _studentInfo = localStorage.getItem("apply_studentInfo");
      const studentInfo = JSON.parse(_studentInfo);
      // console.log("userInfo", userInfo);
      console.log("studentInfo", studentInfo);
      //var winRef = window.open("url","_blank");
      this.downloadBookAct({
        platform: 0,
        category: 2,
        userCode: userInfo.userCode,
        examCode: userInfo.examCode,
        // userCode: userInfo.userCode,
        // examCode: userInfo.examCode,
        // flag: 5,
        // enrollInfoId: studentInfo.enrollInfoId,
        // productPackageName: studentInfo.productPackageName,
        // idName: studentInfo.idName,
        // gender: studentInfo.gender,
        // idPaperType: studentInfo.idPaperType,
        // type: studentInfo.type,
        // idNo: studentInfo.idNo,
        // enrollImageURL: studentInfo.enrollImageURL,
      }).then((res) => {
        // console.log("downloadBookAct", res);
        if (res.data.status == "2000") {
          // let link = `http://${res.data.data}`;
          // window.open(link);
          window.location.href = `http://${res.data.data}`;
          //winRef.location = `http://${res.data.data}`;
        } else {
          this.$warning({
            title: "请注意",
            content: res.data.message,
            okText: "知道了",
            okType: "primary",
            maskClosable: true,
          });
        }
      });
    },

    getExamInfoEvt(_studentInfo) {
      var _userInfo = _studentInfo;
      _userInfo.enrollInfoId = this.$route.query.id;
      this.getExamInfo(_userInfo).then((res) => {
        this.examInfo = res.data.data;
        // console.log("this.examInfo", this.examInfo);
      });
    },
  },
};
</script>

<style scoped>
.my-button {
  display: flex;
  padding: 19px 33px;
  margin: 0 auto;
  align-items: center;
}
.icon-xiazai1 {
  background: url(../assets/images/dan.png);
  width: 18px;
  height: 18px;
  background-size: 100% auto;
  background-repeat: no-repeat;
  margin-right: 10px;
}
.info-area h3 {
  margin-bottom: 0;
  font-size: 20px;
  font-weight: bold;
}
.info-area {
  margin: 30px 0;
  padding: 30px;
  background: #f9f9f9;
}
.box-shadow {
  padding: 20px;
  position: relative;
  box-shadow: 0 0 8px 3px rgba(196, 196, 196, 0.6);
}
.warning-alert {
  margin-top: 20px;
}
.fixed-box {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 100;
  display: flex;
  justify-content: space-around;
  align-items: center;
  overflow: auto;
}
.fixed-box .admission {
  width: 1200px;
}
.admission-info {
  margin: 0 auto;
  color: #333;
}
.download-mask {
  position: absolute;
  width: 1200px;
  height: 750px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
  z-index: 1001;
}
.download-mask.online {
  height: 700px;
}
.download-mask.active {
  background: rgba(255, 255, 255, 0.7);
}
.download {
  width: 200px;
  height: 200px;
  font-size: 24px;
  line-height: 100px;
  text-align: center;
  border-radius: 100px;
  background: rgba(100, 100, 100, 0.8);
  border: none;
}
@media (max-width: 768px) {
  .info-area {
    margin: 0px 0px 30px 0px;
  }
}
</style>
